// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "-" + {"849":"dd290b25403eac85adc3","883":"ccaed3c48a9b702ff445"}[chunkId] + ".chunk.js";
};